"use client";
import CommonCMS from "@lib/constants/contentful/cms-common";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { H } from "@ui/components/content/heading/A11yHeading";
import { Flex } from "@ui/components/layout/flex/Flex";
import type { FC } from "react";

export const NotLoggedIn: FC = () => {
    const { get: getMicrocopy } = useMicrocopy();

    return (
        <Flex bg="gray.50" w="full" px={[4, 4, 16]} py={[6, 6, 12]} justifyContent="center">
            <H size="h3">{getMicrocopy(CommonCMS.shared, CommonCMS.notLoggedIn)}</H>
        </Flex>
    );
};
